/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPACCOUNTHOLDERTYPE } from './IAPACCOUNTHOLDERTYPE';
import {
    IAPACCOUNTHOLDERTYPEFromJSON,
    IAPACCOUNTHOLDERTYPEFromJSONTyped,
    IAPACCOUNTHOLDERTYPEToJSON,
} from './IAPACCOUNTHOLDERTYPE';
import type { IAPBANKACCOUNTTYPE } from './IAPBANKACCOUNTTYPE';
import {
    IAPBANKACCOUNTTYPEFromJSON,
    IAPBANKACCOUNTTYPEFromJSONTyped,
    IAPBANKACCOUNTTYPEToJSON,
} from './IAPBANKACCOUNTTYPE';
import type { IAPBANKNAME } from './IAPBANKNAME';
import {
    IAPBANKNAMEFromJSON,
    IAPBANKNAMEFromJSONTyped,
    IAPBANKNAMEToJSON,
} from './IAPBANKNAME';
import type { IAPBANKVERIFICATIONSTATUS } from './IAPBANKVERIFICATIONSTATUS';
import {
    IAPBANKVERIFICATIONSTATUSFromJSON,
    IAPBANKVERIFICATIONSTATUSFromJSONTyped,
    IAPBANKVERIFICATIONSTATUSToJSON,
} from './IAPBANKVERIFICATIONSTATUS';
import type { IAPBANKVERIFICATIONTYPE } from './IAPBANKVERIFICATIONTYPE';
import {
    IAPBANKVERIFICATIONTYPEFromJSON,
    IAPBANKVERIFICATIONTYPEFromJSONTyped,
    IAPBANKVERIFICATIONTYPEToJSON,
} from './IAPBANKVERIFICATIONTYPE';

/**
 * 
 * @export
 * @interface BankAccountViewModel
 */
export interface BankAccountViewModel {
    /**
     * 
     * @type {number}
     * @memberof BankAccountViewModel
     */
    bankId?: number;
    /**
     * 
     * @type {number}
     * @memberof BankAccountViewModel
     */
    partyId: number;
    /**
     * 
     * @type {IAPBANKNAME}
     * @memberof BankAccountViewModel
     */
    bankNameId?: IAPBANKNAME;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    bankName: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    accountNumber: string;
    /**
     * 
     * @type {IAPBANKACCOUNTTYPE}
     * @memberof BankAccountViewModel
     */
    bankAccountTypeId?: IAPBANKACCOUNTTYPE;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    bankAccountType: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    bankBranchCode: string;
    /**
     * 
     * @type {IAPBANKVERIFICATIONSTATUS}
     * @memberof BankAccountViewModel
     */
    verificationStatus?: IAPBANKVERIFICATIONSTATUS;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    accountHolderName: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    accountHolderSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    accountholderIdentity: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountViewModel
     */
    shouldVerifyBankAccount: boolean;
    /**
     * 
     * @type {IAPACCOUNTHOLDERTYPE}
     * @memberof BankAccountViewModel
     */
    accountHolderType?: IAPACCOUNTHOLDERTYPE;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountViewModel
     */
    canDelete: boolean;
    /**
     * 
     * @type {IAPBANKVERIFICATIONTYPE}
     * @memberof BankAccountViewModel
     */
    verificationType?: IAPBANKVERIFICATIONTYPE;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    whoIsThisAccountFor?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    testCaseName?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    emailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    cellNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountViewModel
     */
    cellNumberDialingCode?: string;
}

/**
 * Check if a given object implements the BankAccountViewModel interface.
 */
export function instanceOfBankAccountViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "bankName" in value;
    isInstance = isInstance && "accountNumber" in value;
    isInstance = isInstance && "bankAccountType" in value;
    isInstance = isInstance && "bankBranchCode" in value;
    isInstance = isInstance && "accountHolderName" in value;
    isInstance = isInstance && "accountholderIdentity" in value;
    isInstance = isInstance && "shouldVerifyBankAccount" in value;
    isInstance = isInstance && "canDelete" in value;

    return isInstance;
}

export function BankAccountViewModelFromJSON(json: any): BankAccountViewModel {
    return BankAccountViewModelFromJSONTyped(json, false);
}

export function BankAccountViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccountViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bankId': !exists(json, 'BankId') ? undefined : json['BankId'],
        'partyId': json['PartyId'],
        'bankNameId': !exists(json, 'BankNameId') ? undefined : IAPBANKNAMEFromJSON(json['BankNameId']),
        'bankName': json['BankName'],
        'accountNumber': json['AccountNumber'],
        'bankAccountTypeId': !exists(json, 'BankAccountTypeId') ? undefined : IAPBANKACCOUNTTYPEFromJSON(json['BankAccountTypeId']),
        'bankAccountType': json['BankAccountType'],
        'bankBranchCode': json['BankBranchCode'],
        'verificationStatus': !exists(json, 'VerificationStatus') ? undefined : IAPBANKVERIFICATIONSTATUSFromJSON(json['VerificationStatus']),
        'accountHolderName': json['AccountHolderName'],
        'accountHolderSurname': !exists(json, 'AccountHolderSurname') ? undefined : json['AccountHolderSurname'],
        'accountholderIdentity': json['AccountholderIdentity'],
        'shouldVerifyBankAccount': json['ShouldVerifyBankAccount'],
        'accountHolderType': !exists(json, 'AccountHolderType') ? undefined : IAPACCOUNTHOLDERTYPEFromJSON(json['AccountHolderType']),
        'canDelete': json['CanDelete'],
        'verificationType': !exists(json, 'VerificationType') ? undefined : IAPBANKVERIFICATIONTYPEFromJSON(json['VerificationType']),
        'whoIsThisAccountFor': !exists(json, 'WhoIsThisAccountFor') ? undefined : json['WhoIsThisAccountFor'],
        'testCaseName': !exists(json, 'TestCaseName') ? undefined : json['TestCaseName'],
        'emailAddress': !exists(json, 'EmailAddress') ? undefined : json['EmailAddress'],
        'cellNumber': !exists(json, 'CellNumber') ? undefined : json['CellNumber'],
        'cellNumberDialingCode': !exists(json, 'CellNumberDialingCode') ? undefined : json['CellNumberDialingCode'],
    };
}

export function BankAccountViewModelToJSON(value?: BankAccountViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BankId': value.bankId,
        'PartyId': value.partyId,
        'BankNameId': IAPBANKNAMEToJSON(value.bankNameId),
        'BankName': value.bankName,
        'AccountNumber': value.accountNumber,
        'BankAccountTypeId': IAPBANKACCOUNTTYPEToJSON(value.bankAccountTypeId),
        'BankAccountType': value.bankAccountType,
        'BankBranchCode': value.bankBranchCode,
        'VerificationStatus': IAPBANKVERIFICATIONSTATUSToJSON(value.verificationStatus),
        'AccountHolderName': value.accountHolderName,
        'AccountHolderSurname': value.accountHolderSurname,
        'AccountholderIdentity': value.accountholderIdentity,
        'ShouldVerifyBankAccount': value.shouldVerifyBankAccount,
        'AccountHolderType': IAPACCOUNTHOLDERTYPEToJSON(value.accountHolderType),
        'CanDelete': value.canDelete,
        'VerificationType': IAPBANKVERIFICATIONTYPEToJSON(value.verificationType),
        'WhoIsThisAccountFor': value.whoIsThisAccountFor,
        'TestCaseName': value.testCaseName,
        'EmailAddress': value.emailAddress,
        'CellNumber': value.cellNumber,
        'CellNumberDialingCode': value.cellNumberDialingCode,
    };
}

